import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CommissionNote\UpdateCommissionNoteItemController::__invoke
* @see app/Http/Controllers/CommissionNote/UpdateCommissionNoteItemController.php
* @route '/api/commission-note/{commission_note}/items/{commission_note_item}'
*/
const UpdateCommissionNoteItemController = (args: { commission_note: string | number | { id: string | number }, commission_note_item: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number }, commission_note_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateCommissionNoteItemController.url(args, options),
    method: 'put',
})

UpdateCommissionNoteItemController.definition = {
    methods: ["put"],
    url: '/api/commission-note/{commission_note}/items/{commission_note_item}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\CommissionNote\UpdateCommissionNoteItemController::__invoke
* @see app/Http/Controllers/CommissionNote/UpdateCommissionNoteItemController.php
* @route '/api/commission-note/{commission_note}/items/{commission_note_item}'
*/
UpdateCommissionNoteItemController.url = (args: { commission_note: string | number | { id: string | number }, commission_note_item: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number }, commission_note_item: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            commission_note: args[0],
            commission_note_item: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        commission_note: typeof args.commission_note === 'object'
        ? args.commission_note.id
        : args.commission_note,
        commission_note_item: typeof args.commission_note_item === 'object'
        ? args.commission_note_item.id
        : args.commission_note_item,
    }

    return UpdateCommissionNoteItemController.definition.url
            .replace('{commission_note}', parsedArgs.commission_note.toString())
            .replace('{commission_note_item}', parsedArgs.commission_note_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CommissionNote\UpdateCommissionNoteItemController::__invoke
* @see app/Http/Controllers/CommissionNote/UpdateCommissionNoteItemController.php
* @route '/api/commission-note/{commission_note}/items/{commission_note_item}'
*/
UpdateCommissionNoteItemController.put = (args: { commission_note: string | number | { id: string | number }, commission_note_item: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number }, commission_note_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateCommissionNoteItemController.url(args, options),
    method: 'put',
})

export default UpdateCommissionNoteItemController